import React from 'react';

import { OrganizationLinksFooterContent } from './components';
import { useOrganizationLinksFooterContentfulData } from './hooks';

export const OrganizationLinksFooter = () => {
  const { contentfulFooter, hasContentfulFooter } =
    useOrganizationLinksFooterContentfulData();

  if (!hasContentfulFooter) return null;

  return <OrganizationLinksFooterContent contentfulFooter={contentfulFooter} />;
};
